export enum TERMSSTATUS_ENUM {
  GENERATED = 'GENERATED',
  UNDERPREPARATION = 'UNDER PREPARATION',
  ACTIVE = 'ACTIVE',
  CLOSEDOUT = 'CLOSED OUT',
};